"use client";

import { Card } from "@/components/ui/card";
import { GradientText } from "@/components/ui/gradient-text";
import { Headphones, Bell, Zap, History, Shield, Sparkles } from "lucide-react";

const features = [
  {
    icon: Headphones,
    title: "First Access",
    description: "Be the first to hear unreleased tracks from your favorite artists"
  },
  {
    icon: Bell,
    title: "Instant Alerts",
    description: "Get notifications within seconds of a new leak dropping"
  },
  {
    icon: Zap,
    title: "Real-time Updates",
    description: "Track multiple versions and updates of unreleased tracks"
  },
  {
    icon: History,
    title: "Leak History",
    description: "Access a comprehensive history of past leaks and their sources"
  },
  {
    icon: Shield,
    title: "Verified Sources",
    description: "Only get alerts from trusted and verified leak sources"
  },
  {
    icon: Sparkles,
    title: "Quality Check",
    description: "We verify audio quality before sending notifications"
  }
];

export function FeaturesSection() {
  return (
    <section id="features" className="py-16 px-4 relative">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold mb-4">
            <GradientText>Stay In The Loop</GradientText>
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            LeakNoti keeps you updated on the latest unreleased tracks from the underground scene to mainstream artists.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <Card key={index} className="group p-6 bg-muted/50 border-muted-foreground/20 hover:border-primary/50 transition-all duration-300 hover:shadow-lg hover:shadow-primary/5">
              <div className="relative w-fit mb-4">
                <div className="absolute -inset-2 bg-gradient-to-r from-primary to-purple-600 rounded-full blur opacity-0 group-hover:opacity-40 transition-opacity" />
                <feature.icon className="h-10 w-10 text-primary relative" />
              </div>
              <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
              <p className="text-muted-foreground leading-relaxed">{feature.description}</p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}